import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import {PPhostedPricing} from '../../../../models/PPhostedPricing.model';
import {ApiService} from '../../../api.service';
import {PricingService} from '../../../pricing.service';
import {SecurityService} from '../../../security.service';
import {ApiTextService} from '../../../apiServices/text/text.service';
import {preserveWhitespacesDefault} from '@angular/compiler';
import {ThreeCXPricing} from '../../../../models/ThreeCXPricing';
import {log} from 'util';
import {distinct} from 'rxjs/operator/distinct';
import {add} from 'ngx-bootstrap/chronos';
import {PeoplefoneBundlePricing} from '../../../../models/PeoplefoneBundlePricing';
import {InternetOptionModel} from '../../../../models/InternetOption.model';

@Component({
  selector: 'app-pf-bundle',
  templateUrl: './pfBundle.component.html',
  styleUrls: ['./pfBundle.component.scss']
})
export class PfBundleComponent implements OnInit, OnDestroy {

  pricingList: PeoplefoneBundlePricing[];
  types: String[];
  internetProviders: String[];
  portings: String[];
  routers: InternetOptionModel[];

  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    private tApi: ApiTextService,
    private api: ApiService,
    private pricing: PricingService) {
    this.pricingList = [];

    pricing.getPfBundlePriceList().then(data => {
      this.pricingList = data;
      this.types = this.getTypes();
      this.internetProviders = this.getInternetProviders();
      this.portings = this.getNumbersPorting();
      this.portings.push('None');
      this.routers = this.getRouters();
      this.getValue().then(() => {
        this.updateMonthlyCosts();
      });
    });
  }

  ngOnInit() {
    //const element = document.getElementById('pfBundle');
    //element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['PeoplefoneBundle'];
  }

  ngOnDestroy() {
    //const element = document.getElementById('pfBundle');
    //element.classList.remove('active');
  }


  setValue(event: any, field: string, value) {
    const data = this.dataStorageService.currentState.peoplefoneBundle;
    switch (field) {
      case 'type':
        data.type = event.target.value;
        break;
      case 'internetProvider':
        data.spec = event.target.value;
        data.router = 'No router';
        data.routerCostUnique = 0;
        break;
      case 'numbersPorting':
        data.numbersPorting = event.target.value !== 'None' ? event.target.value : null;
        break;
      case 'router':
       // console.log(this.routers.find(e => e.option === value).uniqueCost);
        data.routerCostUnique = this.routers.find(e => e.option === value).uniqueCost;
        data.router = value !== 'No router' ? value : null;
    }

    this.updateMonthlyCosts();
  }

  getTypes() {
    return Array.from(new Set(this.pricingList.map(x => x.type))).filter(function (value, index, array) {
      return !(value.includes('Porting'));
    }).sort((a, b) => {
      switch (a){
        case 'Basic':
          return -1;
        case 'Advanced':
          if(b !== 'Basic') {
            return -1;
          }
          return 0;
        case 'Full':
          if(b !== 'Professional') {
            return 1;
          }
          return 0;
        case 'Professional':
          return 1;
        default:
          return 0;
      }
    });
  }

  getNumbersPorting() {
    return Array.from(new Set(this.pricingList.map(x => x.spec))).filter(function (value, index, array) {
      return value.length <= 3;
    });
  }

  getInternetProviders() {
    return Array.from(new Set(this.pricingList.map(x => x.spec))).filter(function (value) {
      return value.length > 3;
    });
  }

  getRouters() {
    switch (this.dataStorageService.currentState.peoplefoneBundle.spec) {
      case 'Cyberlink':
        return this.dataStorageService.typeOfRouterCYBERLINK;
      case 'IPWorldcom':
        return this.dataStorageService.typeOfRouterIPWORLDCOM;
      default:
        return null;
    }
  }

  putValue() {
    return this.api.putPfBundle(this.dataStorageService.currentState.offerID);
  }

  getValue() {
    return this.api.getPfBundle(this.dataStorageService.currentState.offerID);
  }

  getSubscriptionPricing(type: String, spec: String): PeoplefoneBundlePricing {
    return this.pricingList.find(e => e.type === type && e.spec === spec);
  }

  getPortingPricing(porting: String): PeoplefoneBundlePricing {
    return this.pricingList.find(e => e.type === 'Porting' && e.spec === porting);
  }

  getSubscriptionCosts() {
    return this.dataStorageService.currentState.peoplefoneBundle.costMonthly;
  }

  getRouterCosts() {
    return this.dataStorageService.currentState.peoplefoneBundle.routerCostUnique;
  }

  getNumbersPortingCosts() {
    return this.dataStorageService.currentState.peoplefoneBundle.costUnique;
  }

  getSelectedRouter(router: InternetOptionModel) {
    const data = this.dataStorageService.currentState.peoplefoneBundle;
    if (router.option === 'No router' && data.router == null) {
      return true;
    } else {
      return data.router === router.option;
    }
  }

  updateMonthlyCosts() {
    const data = this.dataStorageService.currentState.peoplefoneBundle;
    const subscriptionPricing = this.getSubscriptionPricing(data.type, data.spec);
    const portingPricing = this.getPortingPricing(data.numbersPorting);
    data.costMonthly = subscriptionPricing.costMonthly;
    data.costUnique = portingPricing !== undefined ? portingPricing.costUnique : 0;
    this.routers = this.getRouters();
    this.putValue();
  }

  cancelClick() {
    this.dataStorageService.currentState.peoplefoneBundle.type = 'Basic';
    this.dataStorageService.currentState.peoplefoneBundle.spec = 'IPWorldcom';
    this.dataStorageService.currentState.peoplefoneBundle.numbersPorting = null;
    this.dataStorageService.currentState.peoplefoneBundle.router = null;
    this.updateMonthlyCosts();
  }

  logData() {
    console.log(this.dataStorageService.currentState.peoplefoneBundle);
    console.log(this.pricingList);
    console.log(this.dataStorageService.bundlePricing);
  }

  getSelectedPorting(porting: String) {
    const data = this.dataStorageService.currentState.peoplefoneBundle;
    if (data.numbersPorting == null && porting === 'None') {
      return true;
    }
    return data.numbersPorting === porting;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplefone-bundle/pfBundle.component.ts